export let CalculatorScore = (
  transcripts,
  user_data,
  rec_duration,
  category,
  startTime,
  keyword_length = 0,
  PTECore,
  dictionary
) => {
   

  // let transcript_arr = transcript.split(/[ .,-)]+/);
  console.log(
    keyword_length,
    "Keyword length",
    rec_duration,
    "Rec duration",
    dictionary
  );

  let shortPauseCount = 0;
  let longPauseCount = 0;
  if (startTime !== null && startTime?.length !== 0) {
    for (let i = 0; i < startTime?.length - 1; i++) {
      console.log("Start time  : ", startTime);
      let difference = startTime[i + 1] - startTime[i];
      if (i != 0) {
        if (difference >= 1500 && difference < 3000) {
          shortPauseCount += 1;
          console.log(shortPauseCount);
        }
        if (difference >= 3000) {
          // alert("add 1 to long pause count");
          longPauseCount += 1;
          console.log(longPauseCount);
        }
      }
    }
  }

  const transcript_arr = transcripts
    .replace(/(\d),(?=\d)/g, "$1")
    .replaceAll("%", " percent")
    .split(/[\(\),\s]+/)
    .filter(Boolean)
    .map((transcript) => transcript.replace(/\./g, "").trim());

  const user_data_arr = user_data
    .replace(/(\d),(?=\d)/g, "$1")
    .replace("%", " percent")
    .split(/[\(\),\s]+/)
    .filter(Boolean)
    .map((user_rec) => user_rec.replace(/\./g, "").trim());

  console.log(transcript_arr, "Transcript Array");
  console.log(user_data_arr, "User Data Array");
  // console.log(transcript_arr);
  // console.log(user_data_arr);
  // console.log("long pause");
  // console.log(longPauseCount);
  // console.log("short pause");
  // console.log(shortPauseCount);
  // let user_data_arr = user_data.split(/[ .,-]+/);
  let word_in_post =
    keyword_length > 0 ? keyword_length : transcript_arr.length;

  let recognized_word = 0;
  let regPattern = /[\d\W]+/;
  const rm_number_from_char_arr = user_data_arr.filter(
    (item) => !item.match(regPattern)
  );

  const user_word_arr =
    category === "sgd" &&
    rm_number_from_char_arr.filter((word) => {
      return dictionary.check(word);
    });

  console.log("user_data_arr :", user_data_arr);
  console.log("user_word_arr : ", user_word_arr);

  transcript_arr.forEach((check_char) => {
    if (user_data_arr.includes(check_char)) {
      if (category === "ra" || category === "rs" || category === "sgd") {
        let indexToRemove = user_data_arr.findIndex((item) =>
          item.includes(check_char)
        );

        user_data_arr.splice(indexToRemove, 1);
      }
      recognized_word += 1;
    }
  });
  console.log(recognized_word, "Recognized word count");
  let pronunciation_percentage = parseInt(
    (recognized_word / word_in_post) * 100
  );

  let pronunciation;

  switch (true) {
    case pronunciation_percentage > 85:
      pronunciation = 5;

      break;
    case pronunciation_percentage > 70 && pronunciation_percentage <= 85:
      pronunciation = 4;
      break;
    case pronunciation_percentage > 50 && pronunciation_percentage <= 70:
      pronunciation = 3;

      break;
    case pronunciation_percentage > 30 && pronunciation_percentage <= 50:
      pronunciation = 2;
      break;
    case pronunciation_percentage <= 30 && pronunciation_percentage > 10:
      pronunciation = 1;
      break;

    default:
      pronunciation = 0;
      break;
  }

  let recording_duration =
    category === "rs" || category === "asq"
      ? 10
      : category === "sgd"
      ? 120 // SGD gets 120 seconds (2 minutes)
      : 40; // Default for other categories
  console.log("user_word_arr.length :: ", user_word_arr.length);
  let wpm =
    category == "sgd"
      ? (user_word_arr.length * 60) / rec_duration
      : (recognized_word * recording_duration) / rec_duration;

  console.log("WPM : ", wpm);
  console.log("REC duration: ", rec_duration);
  let fluency_penesentage =
    category == "sgd"
      ? (parseInt(wpm) / 150) * 100
      : (parseInt(wpm) / word_in_post) * 100;

  {
    category == "sgd" &&
      console.log(
        "Fluency percentage: ",
        fluency_penesentage,
        " WPM : ",
        wpm,
        " REC duration: ",
        rec_duration
      );
  }

  // let fluency_penesentage = 50;
  let fluency;
  if (category === "sgd") {
    /* SGD Fluency Expectations:
       - Ideal range: ~50-70 words in 2 minutes
       - Penalize both too slow AND too fast delivery */
    //  Standard wpn for speaking is 125-150
    fluency = Math.min(wpm / 30, 5); // Scale to 5-point (e.g. 75 WPM = 5, 150 WPM=5)

    // Strong pause penalties for SGD
    let pausePenalty = shortPauseCount * 0.3 + longPauseCount * 0.7;
    fluency = Math.max(0, fluency - pausePenalty);
    console.log("Finall FLuency: ", fluency);
  } else {
    // ... (original fluency logic for other types) ...
    switch (true) {
      case fluency_penesentage > 85:
        fluency = 5;

        break;
      case fluency_penesentage > 70 && fluency_penesentage <= 85:
        fluency = 4;
        break;
      case fluency_penesentage > 40 && fluency_penesentage <= 60:
        fluency = 3;
        break;
      case fluency_penesentage > 20 && fluency_penesentage <= 40:
        fluency = 2;
        break;
      case fluency_penesentage > 10 && fluency_penesentage <= 20:
        fluency = 1;
        break;
      default:
        fluency = 0;
        break;
    }
  }
  console.log("FLuency1: ", fluency);
  // let wpm = fluency;
  let content;
  let content_presentage = parseInt((recognized_word / word_in_post) * 100);
  console.log(content_presentage, "Content Percentage");
  // console.log("content presentage", content_presentage

  // let content_penesentage = parent()
  if (category === "rs") {
    switch (true) {
      case content_presentage >= 100:
        content = 3;
        break;
      case content_presentage > 50 && content_presentage < 100:
        content = 2;
        break;
      case content_presentage <= 50 && content_presentage > 25:
        content = 1;
        break;

      default:
        content = 0;
        break;
    }
  } else if (category === "rts" && PTECore) {
    // PTE Core RTS uses 0-3 scale for Appropriacy
    console.log("RTS CORE - Using 0-3 scale for Appropriacy", "PTECore:", PTECore);
    switch (true) {
      case content_presentage >= 100:
        content = 3;
        break;
      case content_presentage > 50 && content_presentage < 100:
        content = 2;
        break;
      case content_presentage <= 50 && content_presentage > 25:
        content = 1;
        break;

      default:
        content = 0;
        break;
    }
  } else if (category === "asq") {
    content = content_presentage >= 50 ? 1 : 0;
  } else if (category === "sgd") {
    // Special content scoring for SGD
    content_presentage = Math.min(content_presentage, 100); // Cap at 100%

    content = (content_presentage / 100) * 6; // Scale to 6-point scale,as content score is 6
  } else if (category === "rts" && !PTECore) {
    console.log("RTS ACADEMY - Using 0-6 scale for Content", "PTECore:", PTECore);
    switch (true) {
      case content_presentage > 90:
        content = 6;
        break;
      case content_presentage > 75 && content_presentage <= 90:
        content = 5;
        break;
      case content_presentage > 60 && content_presentage <= 75:
        content = 4;
        break;
      case content_presentage > 40 && content_presentage <= 60:
        content = 3;

        break;
      case content_presentage > 30 && content_presentage <= 40:
        content = 2;
        break;
      case content_presentage > 20 && content_presentage <= 30:
        content = 1.5;
        break;
      case content_presentage <= 20 && content_presentage > 10:
        content = 1;
        break;

      default:
        content = 0;
        break;
    }
  } else if (category === "di" && !PTECore) {
    console.log("DI ACADEMY - Using 0-6 scale for Content", "PTECore:", PTECore);
    switch (true) {
      case content_presentage > 90:
        content = 6;
        break;
      case content_presentage > 75 && content_presentage <= 90:
        content = 5;
        break;
      case content_presentage > 60 && content_presentage <= 75:
        content = 4;
        break;
      case content_presentage > 40 && content_presentage <= 60:
        content = 3;
        break;
      case content_presentage > 30 && content_presentage <= 40:
        content = 2;
        break;
      case content_presentage > 20 && content_presentage <= 30:
        content = 1.5;
        break;
      case content_presentage <= 20 && content_presentage > 10:
        content = 1;
        break;

      default:
        content = 0;
        break;
    }
  } else {
    switch (true) {
      case content_presentage > 90:
        content = 5;

        break;
      case content_presentage > 60 && content_presentage <= 90:
        content = 4;
        break;
      case content_presentage > 40 && content_presentage <= 60:
        content = 3;

        break;
      case content_presentage > 30 && content_presentage <= 40:
        content = 2;
        break;
      case content_presentage > 20 && content_presentage <= 30:
        content = 1.5;
        break;
      case content_presentage <= 20 && content_presentage > 10:
        content = 1;
        break;

      default:
        content = 0;
        break;
    }
  }
  console.log("Content Before scaling : ", content);
  if (category === "rs") {
    content = (content_presentage * 3) / 100 + 0.2;
    content = content > 3 ? 3 : content;
  } else if (category === "rts" && PTECore) {
    console.log("RTS CORE Scaling - 3-point scale", "PTECore:", PTECore);
    content = (content_presentage * 3) / 100 + 0.2;
    content = content > 3 ? 3 : content;
  } else if ((category === "rts" && !PTECore) || (category === "di" && !PTECore) || category == "sgd") {
    console.log("RTS/DI ACADEMY or SGD Scaling - 6-point scale", "PTECore:", PTECore, "category:", category);
    content = (content_presentage * 6) / 100 + 0.2;
    content = content > 6 ? 6 : content;
    console.log("Content scaling : ", content);
  } else if (category !== "asq") {
    console.log("DI CORE or RL Scaling - 5-point scale", "PTECore:", PTECore, "category:", category);
    content = (content_presentage * 5) / 100 + 0.2;
    content = content > 5 ? 5 : content;
  }

  console.log("Content Before scaling1 : ", content);
  fluency = (fluency_penesentage * 5) / 100;

  let content_max_point =
    category === "rs"
      ? 3
      : category === "rts" && PTECore
      ? 3
      : category === "asq"
      ? 1
      : (category === "rts" && !PTECore) || (category === "di" && !PTECore) || category === "sgd"
      ? 6
      : category === "di" && PTECore
      ? 5
      : 5;
  console.log("content_max_point:", content_max_point, "category:", category, "PTECore:", PTECore);
  // let max_point = category == "rs" ? 3 : 5;

  // if (pronunciation < content) {
  //   switch (pronunciation) {
  //     case content - 1:
  //       fluency += 0.2;
  //       break;
  //     case content - 2:
  //       fluency += 0.5;
  //       break;
  //     case content - 3:
  //       fluency += 0.8;
  //       break;
  //     case content - 4:
  //       fluency += 1;
  //       break;
  //     default:
  //       break;
  //   }
  // }
  fluency = fluency > 5 ? 5 : fluency;
  console.log("Content : ", content);
  if (category !== "rs" && fluency > content) {
    switch (true) {
      case fluency >= content + 1 && fluency < content + 1.5:
        fluency -= 0.3;

        break;
      case fluency >= content + 1.5 && fluency < content + 2:
        fluency -= 0.8;

        break;
      case fluency >= content + 2 && fluency < content + 2.5:
        fluency -= 1.2;

        break;
      case fluency >= content + 2.5 && fluency < content + 3:
        fluency -= 1.8;

        break;
      case fluency >= content + 3 && fluency < content + 3.5:
        fluency -= 2.0;
        break;
      case fluency >= content + 3.5 && fluency < content + 4:
        fluency -= 2.5;

        break;
      case fluency >= content + 4:
        fluency -= 3;

        break;
      default:
        break;
    }
  }

  if (category === "rs" && fluency > content) {
    switch (true) {
      case fluency >= content + 3 && fluency < content + 3.5:
        fluency -= 1;
        break;
      case fluency >= content + 3.5 && fluency < content + 4:
        fluency -= 1.5;
        break;
      case fluency >= content + 4:
        fluency -= 2;
        break;
      default:
        break;
    }
  }

  //fluency based on pause count
  console.log("Pause short", shortPauseCount, " : long : ", longPauseCount);
  if (shortPauseCount >= 1 || longPauseCount >= 1) {
    let minusShortPausePoint = shortPauseCount * 0.3;
    let minusLongPausePoint = longPauseCount * 0.6;

    fluency = fluency - (minusLongPausePoint + minusShortPausePoint);
    fluency = fluency < 0 ? 0 : fluency;
  }

  // console.log("fluency after pause");
  // console.log(fluency);
  // pronunciation = Math.round(pronunciation);
  // content = Math.round(content);
  // fluency = Math.round(fluency);

  console.log(
    content,
    "content",
    fluency,
    "fluency",
    pronunciation,
    "pronunciation"
  );
  let pronunciation_ninety =
    (pronunciation / 5) * 90 < 10 ? 10 : (pronunciation / 5) * 90;
  let content_ninety =
    category === "asq"
      ? content
      : (content / content_max_point) * 90 < 10
      ? 10
      : (content / content_max_point) * 90;

  fluency = fluency > 5 ? 5 : fluency;
  let fluency_ninety = (fluency / 5) * 90 < 10 ? 10 : (fluency / 5) * 90;

  let overall_points = pronunciation + content + fluency;

  // let check_min_ten_mark =
  let overall_points_ninety =
    (pronunciation_ninety + content_ninety + fluency_ninety) / 3;

  let scores = {
    pronunciation: pronunciation,
    fluency: fluency,
    content: content,
    overall_points: Math.round(overall_points),
    number_of_recognized_words: recognized_word,
    number_of_words_in_post: word_in_post,
    length_of_recording_in_sec: rec_duration,
    fluency_ninety: Math.round(fluency_ninety),
    pronunciation_ninety: Math.round(pronunciation_ninety),
    content_ninety: Math.round(content_ninety),
    overall_points_ninety: Math.round(overall_points_ninety),
  };

  return scores;
};
